import { AxiosError } from 'axios';
import instance from '../config/axios';

export async function removeDosageDiaryFromProfile(
  token: string,
  productId: number,
) {
  try {
    const result = await instance({
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `/api/v1/dosasgedairy/profile/product/${productId}`,
    });

    return result.status;
  } catch (e) {
    console.log(e);
    return ((e as AxiosError).response!.data as { message: string }).message;
  }
}
